import { without } from 'underscore';
import { useCallback, useState, useContext, useEffect, useRef } from 'react';
import { ActuationContext } from './actuation-context';
import { getActuatorId } from './actuator-id';

export const useActuatorsTracking = ({ activate, needsActivation, debugMode: debugModeFromProps }) => {
  const parentContext = useContext(ActuationContext);
  const isIsolated = !parentContext;
  const {
    registerActuator: parentRegisterActuator,
    unregisterActuator: parentUnregisterActuator,
    debugMode: parentDebugMode,
  } = isIsolated ? {} : parentContext;
  const debugMode = debugModeFromProps || parentDebugMode;

  const actuatorsRef = useRef([]);

  const activateCallback = useCallback((phase) => {
    activate({ phase, actuators: actuatorsRef.current });
  }, [activate]);

  const registerActuator = useCallback((beacon) => {
    actuatorsRef.current = [...actuatorsRef.current, beacon];
  }, []);
  const unregisterActuator = useCallback((beacon) => {
    actuatorsRef.current = without(actuatorsRef.current, beacon);
  }, []);
  const needsActivationQuery = useCallback(phase => needsActivation({ phase, actuators: actuatorsRef.current }), [needsActivation]);

  const [actuatorId, setBeaconId] = useState(-1);
  useEffect(() => {
    const id = getActuatorId();
    setBeaconId(id);
    const beacon = {
      id, activate: activateCallback, needsActivation: needsActivationQuery,
    };
    if (!isIsolated) {
      parentRegisterActuator(beacon);
    }
    return () => {
      if (!isIsolated) {
        parentUnregisterActuator(beacon);
      }
    };
  }, [activateCallback, needsActivationQuery, isIsolated, parentRegisterActuator, parentUnregisterActuator]);

  return {
    isIsolated,
    actuatorId,
    registerActuator,
    unregisterActuator,
    actuatorsRef,
    debugMode,
  };
};
